// extracted by mini-css-extract-plugin
export default {"quarterContainer":"YearCalendar_quarterContainer__fT5x0"};